import { IChildProp } from '@intelligence/components/Form/type';

const GENRE_PROFILE_DOWNLOAD_SET: IChildProp[] = [
  {
    enumKey: 'gamePlatform',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'mobile',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:entityType:mobile',
      },
      {
        enumKey: 'pc',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:entityType:pc',
      },
      {
        enumKey: 'console',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:entityType:console',
      },
      {
        enumKey: 'total',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:entityType:total',
      },
    ],
  },
  {
    enumKey: 'genre',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [
      {
        enumKey: 'mainGenre',
        enumTargetType: 'genre',
        defaultSelectCondition: 'additionalFields:genreType:main',
      },
      {
        enumKey: 'subGenre',
        enumTargetType: 'genre',
        defaultSelectCondition: 'additionalFields:genreType:sub',
      },
      {
        enumKey: 'mainSubGenre',
        enumTargetType: 'genre',
        defaultSelectCondition: 'additionalFields:genreType:mainsub',
      },
    ],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [
      {
        enumKey: 'timeSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        children: [
          {
            enumKey: 'isTimeAggregated',
            enumTargetType: 'downloadDataCalcu',
            isDefault: true,
          },
          {
            enumKey: 'isSeparateByTime',
            enumTargetType: 'downloadDataCalcu',
          },
        ],
      },
      {
        enumKey: 'regionSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        children: [{
          isDefault: true,
          enumKey: 'isCountryAggregated',
          enumTargetType: 'downloadDataCalcu',
        }, {
          enumKey: 'isSeperateByCountries',
          enumTargetType: 'downloadDataCalcu',
        }, {
          enumKey: 'isSeperateByRegion',
          enumTargetType: 'downloadDataCalcu',
        }]
      },
      {
        enumKey: 'ratio',
        enumTargetType: 'downloadMainCategory',
        type: 'switch',
        isDefault: true,
      },
      {
        enumKey: 'genreCategory',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        // 注意这里，这里的层级是sub，要取parent上的值
        condition: 'parent:gamePlatform:mobile',
        children: [{
          enumKey: 'ieggGenre',
          enumTargetType: 'genre',
          defaultSelectCondition: 'additionalFields:genreSource:iegg',
        }, {
          enumKey: 'dataaiGenre',
          enumTargetType: 'genre',
          defaultSelectCondition: 'additionalFields:genreSource:appannie',
        }]
      }
    ],
  },
  {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'exportAllData',
        enumTargetType: 'downloadOther',
        isDefault: true,
      },
      {
        enumKey: 'selectTop',
        enumTargetType: 'downloadOther',
      },
    ],
  },
  {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  },
  {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  },
];

const GENRE_PROFILE_STATS_DOWNLOAD_SET: IChildProp[] = [
  {
    enumKey: 'gamePlatform',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'mobile',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:entityType:mobile',
      },
      {
        enumKey: 'pc',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:entityType:pc',
      },
      {
        enumKey: 'console',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:entityType:console',
      },
    ],
  },
  {
    enumKey: 'dataCategory',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'operation',
      enumTargetType: 'dataCategory',
      defaultSelectCondition: 'additionalFields:dataType:operation',
    }, {
      enumKey: 'byGames',
      enumTargetType: 'dataCategory',
      defaultSelectCondition: 'additionalFields:dataType:games',
    }, {
      enumKey: 'byCountries',
      enumTargetType: 'dataCategory',
      defaultSelectCondition: 'additionalFields:dataType:countries',
    }, {
      enumKey: 'byCompanies',
      enumTargetType: 'dataCategory',
      defaultSelectCondition: 'additionalFields:dataType:companies',
    }]
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
        isDefault: true,
      }, {
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }],
  },
  {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'exportAllData',
        enumTargetType: 'downloadOther',
        isDefault: true,
      },
      {
        enumKey: 'selectTop',
        enumTargetType: 'downloadOther',
      },
    ],
  },
  {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  },
  {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  },
];

export default {
  genreProfile: GENRE_PROFILE_DOWNLOAD_SET,
  genreProfileStats: GENRE_PROFILE_STATS_DOWNLOAD_SET
};
